// eslint-disable-next-line no-shadow
export enum HubriseAuthResource {
    ORDERS = 'orders',
    CUSTOMER_LIST = 'customer_list',
    CATALOG = 'catalog',
    INVENTORY = 'inventory',
    ALL_CUSTOMER_LISTS = 'all_customer_lists',
    ALL_CATALOG_LISTS = 'all_catalogs'
}
